import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

export type CGUDialogProps = {
  onClose?: () => void
  /** Replaces the default "back to the patients list" link of the refuse button. */
  onRefuse?: () => void
  open: boolean
}

export function CGUDialog(props: CGUDialogProps) {
  const { onClose, onRefuse, open } = props
  const { t } = useTranslation()

  const handleClose = (event: {}, reason: string) => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick') return
    onClose?.()
  }

  return (
    <Dialog disableEscapeKeyDown open={open} onClose={handleClose} scroll="paper">
      <DialogTitle>{t('page.createPatient.cguDialog.title')}</DialogTitle>
      <DialogContent>
        {t('page.createPatient.cguDialog.content', { joinArrays: '\n' })
          .split('\n')
          .map((text, index) => {
            const isQuestion = text.endsWith('?')
            return (
              <Typography
                key={index}
                variant={isQuestion ? 'h6' : 'body1'}
                sx={[
                  {
                    color: (theme) => theme.palette.common.black,
                    fontSize: '14px',
                  },
                  isQuestion && {
                    color: '#064eff',
                    fontSize: '16px',
                    mt: '30px',
                    mb: '10px',
                  },
                ]}
              >
                {text}
              </Typography>
            )
          })}
      </DialogContent>
      <DialogActions id="cguActions">
        {onRefuse ? (
          <Button onClick={onRefuse}>{t('page.createPatient.cguDialog.refuseCGUButton.label')}</Button>
        ) : (
          <Button component={Link} to="/patients">
            {t('page.createPatient.cguDialog.refuseCGUButton.label')}
          </Button>
        )}
        <Button id="rgpdButton" onClick={onClose}>
          {t('page.createPatient.cguDialog.acceptCGUButton.label')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
